import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Typography, Grid, withStyles, Tooltip } from '@material-ui/core'
import {
	FileDocument,
	// FileDocumentEdit,
	TransitConnectionVariant,
} from 'mdi-material-ui'
import { selectFormType } from 'actions/signupForm/addOrEdit'
import LargeIconButton from 'components/theme/LargeIconButton'
import styles from './styles'
import language from 'utils/vast-languagepack'

const FormTypes = connect(
	(state) => ({
		formTypeSelected: state.signupForm.addOrEdit.formTypeSelected,
		formID: state.signupForm.addOrEdit.formID,
	}),
	(dispatch) => bindActionCreators({ selectFormType }, dispatch),
)(
	withStyles(styles)(
		({ formTypeSelected, selectFormType, classes, formID }) => {
			const tooltipTitle = (type) => {
				if (formID !== 'new') {
					if (formTypeSelected !== type) {
						return `You cannot change a form's type once it has been created`
					}
					return `This is a ${
						type === 'customIntegration' ? 'custom integration' : type + ' form'
					}`
				}

				return `Create a ${
					type === 'customIntegration' ? 'custom integration' : type + ' form'
				}`
			}

			return (
				<Grid container spacing={24} justify="center">
					<Grid item xs={12}>
						<Typography variant="h5" gutterBottom>
							{language.signupform.add.formTypeCallToAction}
						</Typography>
					</Grid>
					{/* <Tooltip title={tooltipTitle('signup')}>
						<Grid item xs={4}>
							<LargeIconButton
								disabled={formID !== 'new'}
								variant={
									formTypeSelected === 'signup' ? 'contained' : 'outlined'
								}
								onClick={() => selectFormType('signup')}
								Icon={FileDocumentEdit}
							>
								{language.signupform.add.signUpForm}
							</LargeIconButton>
						</Grid>
					</Tooltip> */}
					<Tooltip title={tooltipTitle('custom')}>
						<Grid item xs={4}>
							<LargeIconButton
								// disabled
								disabled={formID !== 'new'}
								variant={
									formTypeSelected === 'custom' ? 'contained' : 'outlined'
								}
								onClick={() => {
									// console.log('Custom forms will be available soon')
									selectFormType('custom')
								}}
								Icon={FileDocument}
							>
								{language.signupform.add.customForm}
							</LargeIconButton>
						</Grid>
					</Tooltip>
					<Tooltip title={tooltipTitle('customIntegration')}>
						<Grid item xs={4}>
							<LargeIconButton
								variant={
									formTypeSelected === 'customIntegration'
										? 'contained'
										: 'outlined'
								}
								onClick={() => selectFormType('customIntegration')}
								disabled={formID !== 'new'}
								Icon={TransitConnectionVariant}
							>
								CUSTOM INTEGRATION
							</LargeIconButton>
						</Grid>
					</Tooltip>
				</Grid>
			)
		},
	),
)

export default FormTypes
